import { Button, cn } from "@ndd/ui";
import { X } from "lucide-react";
import * as React from "react";
import { DRAWER_TEXT } from "./drawer-type-roles";

/** The 60px drawer header: title, subtitle, close, and a divider beneath. */
export function SideDrawerHeader({
  title,
  subtitle,
  closeLabel,
  onClose,
  titleRef,
}: {
  title: string;
  subtitle: string;
  closeLabel: string;
  /** Present when the drawer owns its close control; the Sheet brings its own. */
  onClose?: () => void;
  titleRef?: React.Ref<HTMLHeadingElement>;
}): React.ReactElement {
  return (
    <header className="flex shrink-0 items-start justify-between gap-3 border-b border-border pb-3 pl-5 pr-3.5 pt-4">
      <div className="flex min-w-0 flex-col gap-0.5">
        <h2
          ref={titleRef}
          tabIndex={-1}
          data-drawer-title=""
          className={cn(DRAWER_TEXT.title, "outline-none")}
        >
          {title}
        </h2>
        <p className={DRAWER_TEXT.meta}>{subtitle}</p>
      </div>
      {onClose ? (
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label={closeLabel}
          onClick={onClose}
          className="text-muted-foreground"
        >
          <X aria-hidden="true" />
        </Button>
      ) : null}
    </header>
  );
}
